
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memberships/[membershipTypeId]",
      function () {
        return require("private-next-pages/memberships/[membershipTypeId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memberships/[membershipTypeId]"])
      });
    }
  